module.exports = __webpack_public_path__ + "img/decrease_indent.36211e50.svg";